var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 *
 */
var State = /** @class */ (function () {
    /**
     *
     * @param state
     * @param init
     */
    function State(state, init) {
        this.state = state;
        this.init = init;
    }
    /**
     *
     * @param init
     */
    State.create = function (init) {
        return new State(init(), init);
    };
    /**
     *
     */
    State.prototype.map = function (fn) {
        return fn(this.state);
    };
    /**
     *
     * @param fn
     */
    State.prototype.consume = function (fn) {
        fn(this.state);
    };
    /**
     *
     * @param fn
     */
    State.prototype.update = function (fn) {
        var next = fn(this.state);
        return next === this.state
            ? this
            : new State(next, this.init);
    };
    /**
     *
     * @param key
     */
    State.prototype.prop = function (key) {
        return this.state[key];
    };
    /**
     *
     * @param key
     * @param fn
     */
    State.prototype.mapProp = function (key, fn) {
        return fn(this.prop(key));
    };
    /**
     *
     * @param key
     * @param fn
     */
    State.prototype.consumeProp = function (key, fn) {
        fn(this.prop(key));
    };
    /**
     *
     * @param key
     * @param val
     */
    State.prototype.setProp = function (key, val) {
        var update = {};
        update[key] = val;
        return this.cloneWith(update);
    };
    /**
     *
     * @param ns
     */
    State.prototype.updateWith = function (ns) {
        return this.cloneWith(ns);
    };
    /**
     *
     */
    State.prototype.clear = function (exclude) {
        if (!exclude) {
            return State.create(this.init);
        }
        var cleared = this.init();
        var state = this.state;
        return this.cloneWith(Object
            .keys(exclude)
            .reduce(function (prev, key) {
            // eslint-disable-next-line
            prev[key] = state[key];
            return prev;
        }, cleared));
    };
    /**
     *
     * @param ns the new (partial) state
     */
    State.prototype.cloneWith = function (ns) {
        var _this = this;
        // if no changing keys, return self
        if (!ns) {
            return this;
        }
        // if keys match current state identity, return self
        var index = Object
            .keys(ns)
            .findIndex((function (k) { return ns[k] !== _this.state[k]; }) // eslint-disable-next-line
            .bind(this));
        //
        return (index < 0)
            ? this
            : new State(__assign(__assign({}, this.state), ns), this.init);
    };
    return State;
}());
export { State };
